<template>
    <div class="d-flex flex-column h-100 position-relative">
        <div  class="flexGrow1 overflow-auto" >
            <!-- Loading  -->
            <div v-if="getIsLoadingSupplierIntegrations" class="d-flex flex-column justify-content-center align-items-center" style="height: 90vmin;">
                <label class="fs-larger darker">Loading</label>
                <loader></loader>
            </div>
            
            <div v-if="!getIsLoadingSupplierIntegrations" class="bg-lightest col-sm-12  d-flex flex-column">
                <!-- Integration Group -->
                <div class="mb-3" v-for="integrationGroup in getAllIntegrationsGroupedes" :key="integrationGroup.id">
                    <div v-if="integrationGroup.integrations.length > 0">
                        <!-- Integration Group Title -->
                        <h3>{{integrationGroup.label}}</h3>
                        <div class="dark">{{integrationGroup.description}}</div>

                        <!-- Empty Message -->
                        <div v-if="integrationGroup.integrations.length < 1">
                            <div class="dark p-4">No integrations available</div>
                        </div>

                        <!-- Integration Card -->
                        <div v-else class="d-flex flex-row flex-wrap">
                            <integration-card v-for="integration in getIntegrationsWithoutOCTO(integrationGroup.integrations)" :key="integration.id" :integration="integration" class="m-3" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import IntegrationCard from './components/IntegrationCard'
import loader from '@/tools/loaders/loader1'

export default {
    computed:{
        ...mapGetters([
            'getAllIntegrations',
            'getAllIntegrationsGrouped',
            'getIsLoadingSupplierIntegrations',
        ]),
        getAllIntegrationsGroupedes: function() {
            return [...this.getAllIntegrationsGrouped];
        }
    },
    methods: {
        getIntegrationsWithoutOCTO(integrations) {
            return integrations.filter(i => i.integration !== 210);
        }
    },
    components:{
        IntegrationCard,
        loader
    }
}
</script>



// WEBPACK FOOTER //
// Integrations.vue?b8c11742